// useBackendVersion — 后端真实版本号 + 节点名 (全局单例, 一次请求到处复用)。
//
// 历史坑: 登录卡副标题和侧边栏版本号曾硬编码 "3.13.38"/"vm00 · 深圳",
// 升级后界面永远显示旧版本 (vm001 上也显示 vm00)。现在统一从公开端点
// /api/system-info 取 (version 来自二进制注入的 main.Version)。
//
// v3.19.22: 改用原生 fetch, 不走 api client —— /api/system-info 是公开端点,
// 而 api client 在 request() 开头就 useAuthStore() 取 token: router 模块
// 加载期 (早于 main.ts 的 app.use(pinia)) 调用本 hook 时 pinia 尚未激活,
// 请求在发出前就抛 "no active Pinia" 并被 catch 吞掉, 且 started 已置位,
// 名字/版本永远是空 (标签页标题与登录卡副标题全空白)。公开端点不该
// 依赖 auth store 时序。
import { ref } from 'vue'

const version = ref('')
const nodeName = ref('')
let started = false

export function useBackendVersion(): { version: ReturnType<typeof ref<string>>; nodeName: ReturnType<typeof ref<string>> } {
  if (!started) {
    started = true
    fetch('/api/system-info', { headers: { Accept: 'application/json' } })
      .then((res) => (res.ok ? res.json() : null))
      .then((info: { version?: string; node_name?: string } | null) => {
        if (!info) return
        version.value = info.version || ''
        nodeName.value = info.node_name || ''
      })
      .catch(() => {
        /* 取不到就留空 — 界面隐藏版本行, 不弹错误 */
      })
  }
  return { version, nodeName }
}
